import React from "react";
import { ProviderCard } from "../marketplace/ProviderCard";
import { Icon } from "../core/Icon";

/** Dany's inline provider results: a labelled strip of ProviderCards inside a turn. */
export function DanyProviderResults({ providers = [], caption, minColumnWidth = 300, onSeeAll, seeAllLabel = "See all matches" }) {
  return (
    <div>
      {caption && (
        <p style={{
          display: "flex", alignItems: "center", gap: 6, marginBottom: "var(--space-3)",
          fontFamily: "var(--font-display)", fontSize: "var(--text-xs)",
          textTransform: "uppercase", letterSpacing: "var(--tracking-widest)", color: "var(--dany-meta)",
        }}>
          <Icon name="shield-check" size={12} style={{ color: "var(--dusk)" }} />{caption}
        </p>
      )}
      <div style={{ display: "grid", gridTemplateColumns: `repeat(auto-fit, minmax(min(100%, ${minColumnWidth}px), 1fr))`, gap: "var(--space-3)" }}>
        {providers.map((p, i) => <ProviderCard key={p.id || i} {...p} />)}
      </div>
      {onSeeAll && (
        <button onClick={onSeeAll} style={{
          marginTop: "var(--space-3)", border: "none", background: "transparent", cursor: "pointer",
          padding: 0, display: "inline-flex", alignItems: "center", gap: 6,
          fontFamily: "var(--font-display)", fontSize: "var(--text-sm)",
          fontWeight: "var(--weight-semibold)", color: "var(--text-accent)",
        }}>
          {seeAllLabel}<Icon name="arrow-right" size={15} />
        </button>
      )}
    </div>
  );
}
